@if (activeUser.isLoggedIn()) {
  <p-avatar
    class="cursor-pointer flex"
    [label]="profileImagePath ? undefined : activeUser.userChar()"
    [image]="profileImagePath || undefined"
    [styleClass]="styleClass"
    [size]="size"
    (click)="menu.toggle($event)"
    shape="circle">
    @if (icon && !profileImagePath) {
      <i class="bg-icon" [class]="icon"></i>
    }
  </p-avatar>
} @else if (menuItems.length > 0) {
  <p-button
    icon="fas fa-ellipsis-v"
    [rounded]="true"
    [text]="true"
    [raised]="true"
    styleClass="surface-0"
    (click)="menu.toggle($event)"></p-button>
}
<p-menu
  styleClass="max-h-22rem w-16rem overflow-auto right-0 left-auto"
  #menu
  [model]="menuItems"
  [popup]="true">
  <ng-template pTemplate="submenuheader" let-item>
    <span class="text-color-secondary flex gap-3 align-items-center"
      ><i [class]="item.icon"></i>{{ item.label }}</span
    >
  </ng-template>
  <ng-template pTemplate="item" let-item>
    @if (item.command) {
      <a
        class="p-menuitem-link cursor-pointer"
        (click)="item.command({ originalEvent: $event, item: item })">
        <div class="flex align-items-center">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    } @else if (item.url) {
      <a class="p-menuitem-link" target="_blank" [href]="item.url">
        <div class="flex align-items-center">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    } @else if (item.routerLink) {
      <a
        class="p-menuitem-link"
        [routerLink]="item.routerLink"
        [target]="item.target || '_self'">
        <div class="flex align-items-center">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    }
  </ng-template>
</p-menu>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  [(visible)]="showProfileForm"
  [style]="{ width: '50rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-pencil"
      text="Profil bearbeiten"></app-header>
  </ng-template>
  @if (showProfileForm) {
    <app-user-form
      [selfEditMode]="true"
      [cancelLevel]="0"
      (formSubmitted)="onProfileSaved($event)"
      (cancel)="showProfileForm = false"></app-user-form>
  }
</p-dialog>
